import { render, staticRenderFns } from "./widgetToolbar.vue?vue&type=template&id=4784ebd1&scoped=true"
import script from "./widgetToolbar.vue?vue&type=script&lang=js"
export * from "./widgetToolbar.vue?vue&type=script&lang=js"
import style0 from "./widgetToolbar.vue?vue&type=style&index=0&id=4784ebd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784ebd1",
  null
  
)

export default component.exports